import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import Button from '../Button/index';
import FilterGroup from "./FilterGroup";

import { getFilters } from '../../actions/findActivities/filters/get';
import {toggleFilter} from "../../actions/findActivities/filters/selected";
import { searchActivities, setSearchValue } from "../../actions/findActivities/search/get";

class FilterList extends Component {

    constructor() {
        super();
        this.handleReset = this.handleReset.bind(this);
    }
    componentDidMount() {
        this.props.getFilters(this.props.searchValues);
    }

    handleReset(e){
        e.preventDefault();
        this.props.toggleFilter('', '', true);
        this.props.setListCurrentPage(1);
        this.props.setSearchValue('filters', {});
        this.props.searchActivities(this.props.searchValues, {});
    }
    
    shouldComponentUpdate(nextProps, nextState) {
        if(JSON.stringify(nextProps.searchValues) !== JSON.stringify(this.props.searchValues)) {
            this.props.getFilters(nextProps.searchValues);
        }
        return true;
    }

    render() {
        const { filterGroups, classes, isModalOpen, closeModal } = this.props;

        return (
            <div className={['modal-overlay', isModalOpen && 'is-visible', classes && classes].join(' ')}>
                <MediaQuery maxWidth={767}>
                    <button className="close-button" onClick={closeModal}>
                        <i className="icon icon-close"></i>
                    </button>
                </MediaQuery>
                <div className="filter-container">
                    <div className="filter-header">
                        <h3>Filters</h3>
                        <Button
                            type="button"
                            label="Reset"
                            classes="underline-button"
                            onClick={this.handleReset}
                        />
                    </div>
                    <div className="filter-list">
                        {
                            Object.keys(filterGroups).map((item) => (
                                <FilterGroup filterId={filterGroups[item].id} key={filterGroups[item].id} />
                            ))
                        }
                    </div>
                </div>
            </div>
        );
    }
}

FilterList.propTypes = {
    getFilters:  PropTypes.func.isRequired,
    filterGroups: PropTypes.object,
};

const mapStateToProps = (state) => ({
    filterGroups : state.filterLists,
    searchValues: state.searchValues,
});

const mapDispatchToProps = dispatch => ({
    getFilters: (params) => {
        dispatch(getFilters(params));
    },
    toggleFilter: (id, c, reset ) => {
        dispatch(toggleFilter(id,c, reset));
    },
    setSearchValue: (k,v) => {
        dispatch(setSearchValue(k,v));
    },
    searchActivities: (values, filters, page) => {
        dispatch(searchActivities(values, filters, false, page));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterList);

